const IDX_TO_TEXT = [
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
  "Tenth",
];

export const parseTimelineCustomText = (
  settingText: string | undefined,
  idx: number,
): string => {
  if (settingText != null) {
    return settingText;
  }

  if (idx < IDX_TO_TEXT.length) return IDX_TO_TEXT[idx];

  return "Custom text";
};
